import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import PropTypes from 'prop-types';

import Section from 'components/Section';
import {
    SectionVariants,
    SectionEdgePosition,
} from 'components/Section/constants';
import { CardVariants } from 'components/Card/constants';
import { getFormattedSectionArticles } from 'utilities/getSectionArticles';
import { renderReactComponents } from 'utilities/richTextHandlers';

const SectionContent = ({ data }) => {
    const { linkItem, subsections, textItems, slug } = data.section;
    const articles = getFormattedSectionArticles(subsections);

    return (
        <Section
            animate
            id={slug}
            title={textItems.headerText.headerText}
            subtitle={textItems.subheaderText}
            content={renderReactComponents(textItems.contentText)}
            articles={articles}
            variant={SectionVariants.HIGHLIGHTED}
            cardVariant={CardVariants.WITH_INLINE_IMAGE}
            contentType="article"
            callToActionButtonText={linkItem.text}
            callToActionUrl={linkItem.link}
            hasEdge
            edgePosition={SectionEdgePosition.RIGHT}
            isNavigationItem
            isTrackableAsPage
        />
    );
};

const EducationalResourcesSection = (props) => (
    <StaticQuery
        query={graphql`
            query {
                allContentfulEducationalResourcesSection {
                    nodes {
                        id
                        section {
                            slug
                            textItems {
                                headerText {
                                    headerText
                                }
                                subheaderText
                                contentText {
                                    raw
                                }
                            }
                            linkItem {
                                text
                                link
                            }
                            subsections {
                                textItems {
                                    headerText {
                                        headerText
                                    }
                                    contentText {
                                        raw
                                    }
                                }
                                imageDescription
                                image {
                                    defaultImage: localFile {
                                        childImageSharp {
                                            gatsbyImageData(layout: CONSTRAINED)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `}
        render={({ allContentfulEducationalResourcesSection }) => {
            const item = allContentfulEducationalResourcesSection.nodes.find(
                (node) => node.id === props.id
            );
            return <SectionContent data={item} />;
        }}
    />
);

EducationalResourcesSection.propTypes = {
    id: PropTypes.string.isRequired,
};

SectionContent.propTypes = {
    data: PropTypes.shape({
        section: PropTypes.shape({
            slug: PropTypes.string.isRequired,
            textItems: PropTypes.shape({
                headerText: PropTypes.shape({
                    headerText: PropTypes.string.isRequired,
                }).isRequired,
                subheaderText: PropTypes.string.isRequired,
                contentText: PropTypes.object.isRequired,
            }).isRequired,
            linkItem: PropTypes.shape({
                text: PropTypes.string.isRequired,
                link: PropTypes.string.isRequired,
            }).isRequired,
            subsections: PropTypes.arrayOf(
                PropTypes.shape({
                    textItems: PropTypes.shape({
                        headerText: PropTypes.shape({
                            headerText: PropTypes.string.isRequired,
                        }).isRequired,
                        contentText: PropTypes.object.isRequired,
                    }).isRequired,
                    imageDescription: PropTypes.string.isRequired,
                    image: PropTypes.shape({
                        defaultImage: PropTypes.object.isRequired,
                    }).isRequired,
                }).isRequired
            ).isRequired,
        }).isRequired,
    }).isRequired,
};

export default EducationalResourcesSection;
